// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"tY-z","tooltip":"uY-z","tooltipContent":"vY-z","orderStatusWrapper":"wY-z"};